export default {"src":"/_next/static/media/dashboard-empty.92e29f7d.svg","height":146,"width":258,"blurWidth":0,"blurHeight":0};